export const GET_ALL_CHAMPIONSHIPS = "GET_ALL_CHAMPIONSHIPS";
export const GET_CHAMPIONSHIP_BY_ID = "GET_CHAMPIONSHIP_BY_ID";
export const EDIT_CHAMPIONSHIP = "EDIT_CHAMPIONSHIP";